document.querySelectorAll('.section-inform-modal').forEach((section) => {
  informHandler(section)
});

document.querySelectorAll('.block-inform-modal').forEach((section) => {
  informHandler(section)
});

function informHandler(section) {
  const topInform = section.querySelector('.top-inform');
  const modalInform = section.querySelector('.modal-inform');

  const informBtn = section.querySelector('.top-inform__inform-button');
  const topInformCloseBtn = section.querySelector('.top-inform__close-button');
  const modalInformCloseBtn = section.querySelector('.modal-inform__close-button');

  if (informBtn && modalInform) {
    informBtn.addEventListener('click', () => {
      modalInform.classList.remove('hidden');
    });
  }

  if (modalInformCloseBtn && modalInform) {
    modalInformCloseBtn.addEventListener('click', () => {
      modalInform.classList.add('hidden');
    });
  }

  if (topInformCloseBtn && topInform) {
    topInformCloseBtn.addEventListener('click', () => {
      topInform.classList.add('hidden');
    });
  }

  if (modalInform) {
    modalInform.addEventListener('click', (event) => {
      if (event.target.classList.contains('modal-inform')) {
        modalInform.classList.add('hidden');
      }
    });
  }
}